// Soft UI Dashboard PRO React components
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import PropTypes from 'prop-types';

// Data
import { QueryClient, QueryClientProvider, useQuery } from '@tanstack/react-query';
import { useAuth0 } from "@auth0/auth0-react";
import { useEffect, useState } from "react";

// Components
import ExploringMap from "nextus/Maps/ExploringMaps/Groups";
import MapNav from "nextus/Sidenavs/MapNav";

// API/MODELS
import groupAPI from "api/groups";
import bksAPI from "api/bks";
import clearwaysAPI from "modules/clearways/api";
import userAPI from "api/user";

// Mapbox
import mapboxgl from '!mapbox-gl'; // eslint-disable-line import/no-webpack-loader-syntax
import 'mapbox-gl/dist/mapbox-gl.css';

// helper
import { processDevicesData } from "helper/device";
import MapMenuContent from "nextus/MapMenuContent";
import { processGroupData } from "helper/group";
import { useMatch } from "react-router-dom";
import ExploringMapEventGroups from "nextus/Maps/ExploringMaps/EventGroups";
import { processEventsData } from "helper/event";
import { useSoftUIController } from "context";

mapboxgl.accessToken = 'pk.eyJ1IjoiaGFycnltb250YW5vIiwiYSI6ImNqZWY0bDcyaTFkcGYzM28ydHFpaDJxaWcifQ.Wf7aNVePBRWZ9fMy_I81qw';

function wrapper(map, content) {
    return (
        <SoftBox sx={{ width: '100%', height: '100%' }}>
            {map}
            {content}
        </SoftBox>
    )
}

function ExploreMapEventGroups({ map, navTitle, setNavTitle, sidebarState, setSidebarState }) {
    groupAPI.loadToken(useAuth0());
    bksAPI.loadToken(useAuth0());
    clearwaysAPI.loadToken(useAuth0());
    userAPI.loadToken(useAuth0());

    const { user } = useAuth0();

    const [sidebarOpen, setSidebarOpen] = useState(true);
    const [menuToggled, setMenuToggled] = useState(true);
    const [mapPadding, setMapPadding] = useState([600, 250]);
    const [groupPreviewID, setGroupPreviewID] = useState(0);

    const [controller, dispatch] = useSoftUIController();
    const { miniSidenav, hiddenSidenav, direction, layout, openConfigurator, sidenavColor, deviceStyle } = controller;

    const [eventbarState, setEventbarState] = useState('closed');

    try {
        var { group_ids } = useMatch('explore/event-groups/:group_ids').params;
        group_ids = group_ids.split(',');
    }
    catch (e) {
        var group_ids = [];
    }

    // console.log(group_ids);

    const groups = useQuery({
        queryKey: ['getAllGroups'],
        queryFn: async () => {
            return await groupAPI.getAllGroups();
        }
    });

    const devices = useQuery({
        queryKey: ['getAllDevices'],
        queryFn: async () => {
            return await bksAPI.getAllDevices()
        }
    });

    const events = useQuery({
        queryKey: ['getAllClearways'],
        queryFn: async () => {
            return await clearwaysAPI.getAllClearways();
        },
        // staleTime: 20 * 1000
    });

    const selected_user = useQuery({
        queryKey: ['getUserByEmail', user.email.toLowerCase()],
        queryFn: async () => {
            return await userAPI.getUserByEmail(user.email.toLowerCase());
        }
    });

    useEffect(() => {
        // console.log('explore_map')
        setSidebarState('exploring');
        setNavTitle(['explore map']);

        if (deviceStyle == 'mobile') {
            setMapPadding([0, 0]);
            // setSidebarOpen(false);
        }
        else {
            if (!sidebarOpen) {
                setMapPadding([0, 250]);
                setSidebarOpen(false);
            }
            else {
                setMapPadding([600, 250]);
                setSidebarOpen(true);
            }
        }

    }, [sidebarOpen, navTitle, deviceStyle]);

    if (groups.isLoading || devices.isLoading || selected_user.isLoading || events.isLoading) {
        return wrapper('Loading...');
    }

    if (groups.error || devices.error || selected_user.error) {
        if(groups.error){
            var error = groups.error;
        }
        else if (devices.error){
            var error = devices.error;
        }
        else if (selected_user.error){
            var error = selected_user.error;
        }
        else if (events.error){
            var error = events.error;
        }
        return wrapper("An error has occurred: " + error.message);
    }

    if (!groups.data || !devices.data || !selected_user.data) {
        return wrapper('Loading...');
    }

    // if (events.isLoading) {
    //     return wrapper((<ExploringMapEventGroups map={map} mapPadding={mapPadding} extraPadding={eventbarState == 'open'} groups_data={groups_data} user_role={selected_user.data.user.user_type} selectedEventGroups={parent_group_ids} sidebarOpen={sidebarOpen} menuToggled={menuToggled} setMenuToggled={setMenuToggled} setGroupPreviewID={setGroupPreviewID} />), ('Loading...'));
    // }

    // if (events.error) {
    //     return wrapper((<ExploringMapEventGroups map={map} mapPadding={mapPadding} extraPadding={eventbarState == 'open'} groups_data={groups_data} user_role={selected_user.data.user.user_type} selectedEventGroups={parent_group_ids} sidebarOpen={sidebarOpen} menuToggled={menuToggled} setMenuToggled={setMenuToggled} setGroupPreviewID={setGroupPreviewID} />), ("An error has occurred: " + events.error.message));
    // }

    // if (!events.data) {
    //     return wrapper((<ExploringMapEventGroups map={map} mapPadding={mapPadding} extraPadding={eventbarState == 'open'} groups_data={groups_data} user_role={selected_user.data.user.user_type} selectedEventGroups={parent_group_ids} sidebarOpen={sidebarOpen} menuToggled={menuToggled} setMenuToggled={setMenuToggled} setGroupPreviewID={setGroupPreviewID} />), ('Loading...'));
    // }

    var events_data = processEventsData(events.data);
    var groups_data = groups.data.filter((row) => row.type == "clearways").map(function (group) {
        var ret = processGroupData(group, devices.data);
        return ret;
    }).filter(group => typeof group.parent_id == 'undefined');

    var parent_group_ids = [];
    for (var id of group_ids) {
        for (var group of groups_data) {
            if (group.group_id == id && parent_group_ids.indexOf(group.group_id) == -1) {
                parent_group_ids.push(group.group_id)
            }
            else {
                for (var subgroup of group.subgroups) {
                    if (subgroup.group_id == id && parent_group_ids.indexOf(group.group_id) == -1) {
                        parent_group_ids.push(group.group_id)
                    }
                }
            }
        }
    }

    return wrapper(
        (<ExploringMapEventGroups map={map} mapPadding={mapPadding} extraPadding={events_data.length > 0} groups_data={groups_data} user_role={selected_user.data.user.user_type} selectedEventGroups={parent_group_ids} sidebarOpen={sidebarOpen} menuToggled={menuToggled} setMenuToggled={setMenuToggled} setGroupPreviewID={setGroupPreviewID} deviceStyle={deviceStyle} />),
        (<MapMenuContent sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} groupPreviewID={groupPreviewID} sidebarState={'exploring'} events={events_data} eventbarState={events_data.length > 0 ? 'open' : 'closed'} setEventbarState={setEventbarState} deviceStyle={deviceStyle} />)
    );
}

ExploreMapEventGroups.propTypes = {
    map: PropTypes.object,
    navTitle: PropTypes.array,
    setNavTitle: PropTypes.func,
    sidebarState: PropTypes.string,
    setSidebarState: PropTypes.func,
}

export default ExploreMapEventGroups;